var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34786 17.6039L5.10557 16.6269L5.60229 16.8834C6.75179 17.4756 8.0655 17.7912 9.5 17.7912C14.2446 17.7912 17.6429 14.1917 17.6429 9.86606C17.6429 5.52453 14.269 1.94093 9.5 1.94093C4.731 1.94093 1.35714 5.52453 1.35714 9.86606C1.36516 11.5275 1.88041 13.1414 2.82557 14.4655L3.28429 15.1139L2.34786 17.6024V17.6039ZM1.38836 19.4627C1.26554 19.5064 1.13352 19.5118 1.00788 19.4784C0.882242 19.445 0.768235 19.3741 0.679328 19.2741C0.59042 19.1741 0.530325 19.0491 0.506143 18.914C0.48196 18.7789 0.4947 18.6393 0.542857 18.5117L1.74121 15.3315C0.619102 13.7577 0.00811818 11.8399 0 9.86606C0 5.09081 3.63986 0.5 9.5 0.5C15.3601 0.5 19 5.09081 19 9.86606C19 14.6413 15.3221 19.2321 9.5 19.2321C7.81036 19.2321 6.30121 18.846 5.01057 18.1802L1.387 19.4627H1.38836Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.1ec5b26d7f639f68d73e93d8c572c2eb.svg";
export { ForwardRef as ReactComponent };